import React, { useEffect, useState } from "react";
import lpllogo from "../assets/images/logo.png";
import suburbanlogo from "../assets/images/suburban.webp"
import user from "../assets/images/user.png";
import Dropdown from "react-bootstrap/Dropdown";
import ApiRequest from "../services/apiService";
import GetUserData from "../utilities/getUserDetails";
import baseUrl from "../services/baseUrl";
import NumberFormatter from "../utilities/formatHeaderCounts";
import { ShowToastUtil } from "../utilities/showToastUtil";
import { useNavigate } from "react-router-dom";
import HeaderScreenLoader from "../components/headerScreenLoader";
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [ppdCounts, setPpdCounts] = useState({});
  const [userInfo, setUserInfo] = useState(GetUserData());
  const [IsLoading, setIsLoading] = useState(false);
  const [projectFilter, setProjectFilter] = useState(
    localStorage.getItem("projectFilter") || ""
  );
  const navigate = useNavigate();


  // const [projects, setProjects] = useState([]);

  // Handle scroll event to add/remove scrolled class
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
  };

  // Clear session and local storage on logout
  async function handleLogout() {
    try {
      const params = new URLSearchParams({
        userCode: userInfo.UserCode,
        logoutTime: new Date().toISOString(),
      });
      const url = `${baseUrl()}/nps/RemoveUserTrail?${params.toString()}`;
      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (response.Message === "Success") {
      } else {
        ShowToastUtil(
          response.Description || "Failed to delete user trail",
          "error"
        );
      }
    } catch (error) {
      ShowToastUtil("Something went wrong with user trail deletion", "error");
    }
    navigate('/login');

    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
  }

  // Fetch data for header from API
  useEffect(() => {
    const fetchHeaderData = async () => {
      // Check if the data already exists in localStorage
      const storedData = localStorage.getItem('headerData');
      if (storedData) {
        setPpdCounts(JSON.parse(storedData));
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        const params = new URLSearchParams({
          // projectFilter: localStorage.getItem('projectFilter') || projectFilter,
          userRole: userInfo.UserRole,
          userCode: userInfo.UserCode,
        });
        const url = `${baseUrl()}/nps/GetNpsHeaderData?${params.toString()}`;
        const responseData = await ApiRequest({ apiLink: url, method: 'GET' });
        if (responseData.Data && responseData.IsSuccess) {
          setIsLoading(false);
          const data = responseData.Data.Counts;
          setPpdCounts(data || {});
          localStorage.setItem('headerData', JSON.stringify(data)); // Store data in localStorage
        }
      } catch (error) {
        ShowToastUtil('Error fetching header data:', error);
      }
    };

    fetchHeaderData();
  }, [projectFilter, userInfo.UserRole, userInfo.UserCode]);

  // Add and remove scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleDropdownLogout = () => {
    handleLogout();
  };
  // const isSuburbon = true
  const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
  //Test subourbon
  useEffect(() => {
    // Remove existing favicon link tag(s)
    const existingIcons = document.querySelectorAll('link[rel="icon"]');
    existingIcons.forEach(icon => icon.parentNode.removeChild(icon));

    // Create new favicon link
    const newIcon = document.createElement('link');
    newIcon.rel = 'icon';

    if (isSuburban) {
      newIcon.href = ''; // your custom favicon in public folder
    } else {
      newIcon.href = ''; // default favicon
    }

    document.head.appendChild(newIcon);
  }, [isSuburban]);


  return (
    <header
      className={`main-header container-fluid ${isScrolled ? "scrolled" : ""}`}
    >
      <div className="row">
        <div className="col-12 d-flex align-items-center">
          <a href={'/home'} className="logo">
            {/* <img alt="Dr. Lal Path Labs" src={lpllogo} className="img-fluid" /> */}

            {/* <img alt="Suburban Dignostics" src={suburbanlogo} className="img-fluid" /> */}

            {isSuburban ? (
              <img alt="Suburban Diagnostics India Pvt Limited" src={suburbanlogo} className="img-fluid" />
            ) : (
              <img alt="Dr. Lal Path Labs" src={lpllogo} className="img-fluid" />
            )}
          </a>
          {/* <div className="did-floating-label-content mb-0">
            <select className="did-floating-select w-200px">
              <option key={'Select Project'} value={'Select Project'}>Select Project</option>
              {projects.map((project, index) => (
                <option key={index} value={project.ProjectName}>
                  {project.ProjectName}
                </option>
              ))}
            </select>
            <label className="did-floating-label">Project</label>
          </div> */}
          <div className="ms-auto d-inline-flex">
            <div className="h-promotors me-3">
              <div>
                <span>Promoters</span>
                <span className="smily">
                  <i className="fa fa-smile-o" aria-hidden="true"></i>
                </span>
                <div className="count-number">
                  {IsLoading || !ppdCounts.Promoters ? (
                    <div className="">
                      <HeaderScreenLoader />
                    </div>
                  ) : (
                    <NumberFormatter number={ppdCounts.Promoters || 0} />
                  )}
                </div>
              </div>
            </div>
            <div className="h-passives me-3">
              <div>
                <span>Passives</span>
                <span className="smily">
                  <i className="fa fa-meh-o" aria-hidden="true"></i>
                </span>
                <div className="count-number">
                  {IsLoading || !ppdCounts.Promoters ? (
                    <div className="">
                      <HeaderScreenLoader />
                    </div>
                  ) : (
                    <NumberFormatter number={ppdCounts.Passives || 0} />
                  )}
                </div>
              </div>
            </div>
            <div className="h-detractors me-3">
              <div>
                <span>Detractors</span>
                <span className="smily">
                  <i className="fa fa-frown-o" aria-hidden="true"></i>
                </span>
                <div className="count-number">
                  {IsLoading || !ppdCounts.Promoters ? (
                    <div className="">
                      <HeaderScreenLoader />
                    </div>
                  ) : (
                    <NumberFormatter number={ppdCounts.Detractors || 0} />
                  )}
                </div>
              </div>
            </div>
            <div className="user-info me-3">
              <Dropdown align={{ sm: "end" }}>
                <Dropdown.Toggle variant="user-icon">
                  <img alt="" src={user} className="user-image img-fluid" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div className="text-center user-N">
                    <span>Welcome</span>
                    <div className="text-nowrap user-name">
                      {userInfo.UserName}
                    </div>
                    <div className="user-designation">{userInfo.UserRole}</div>
                  </div>
                  <Dropdown.Item className="user-option" href="resetPassword">
                    <i className="fa fa-lock" aria-hidden="true"></i> Reset
                    Password
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleDropdownLogout} className="user-option">
                    <i className="fa fa-sign-out" aria-hidden="true"></i> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
